__turbopack_context__.v({
  "disabled": "checkbox-module__HcVKBa__disabled",
  "label": "checkbox-module__HcVKBa__label",
  "wrapper": "checkbox-module__HcVKBa__wrapper",
});
